import SettingsRowList from './SettingsRowList';
import { SettingsRowListProps, SettingsRowListValueProps } from './types';

export type { SettingsRowListProps, SettingsRowListValueProps };
export default SettingsRowList;
